import { createContext } from 'react';

export const PanelConfigContext = createContext({});